import React from 'react';
import { SelecteurVariables } from './SelecteurVariables';

export interface TokenDef { token: string; desc: string; }

/** Variables {{...}} d'un message libre — insère à la position du curseur dans le textarea associé au
 *  lieu de se contenter de l'afficher, pour éviter d'avoir à le retaper à la main.
 *
 *  Même panneau que les e-mails de Paramètres › Notifications (SelecteurVariables) : variables rangées
 *  par famille, avec exemple, plutôt qu'une rangée de codes bruts. Ici seules les variables de l'écran
 *  sont montrées, sous le libellé que l'écran leur donne. */
export function TokenPicker({
    tokens,
    textareaRef,
    value,
    onChange,
}: {
    tokens: TokenDef[];
    textareaRef: React.RefObject<HTMLTextAreaElement | null>;
    value: string;
    onChange: (v: string) => void;
}) {
    const variables = React.useMemo(() => tokens.map((t) => ({ token: t.token, label: t.desc })), [tokens]);

    const insert = (token: string) => {
        const el = textareaRef.current;
        if (!el) { onChange(value + token); return; }
        const start = el.selectionStart ?? value.length;
        const end = el.selectionEnd ?? value.length;
        const next = value.slice(0, start) + token + value.slice(end);
        onChange(next);
        requestAnimationFrame(() => {
            // blur puis focus : le champ défile jusqu'au curseur, donc jusqu'à la variable posée.
            el.blur();
            el.focus();
            const pos = start + token.length;
            el.setSelectionRange(pos, pos);
        });
    };

    return <SelecteurVariables tokens={variables} onInsertToken={insert} seulementEcran />;
}
